export default "__VITE_ASSET__J5wm5NGk__"